<div class="container-fluid maap-root-container">
 <app-header
            [showWitness]="true" 
            [deId]="deId"
            [dissableDeIdSwitch]="dissableDeIdSwitch"
            (deIdChange)="updateDeIdMode($event)">
 </app-header>

 <app-sidebar [deId]="deId"
              [dissableDeIdSwitch]="dissableDeIdSwitch"
              (deIdChange)="updateDeIdMode($event)">
 </app-sidebar>

  <header class="standalone-page-header assay-page-header">
    <h1 class="standalone-page-title">Assay Management</h1>
  </header>

  <div class="row">
      <div  class="col-md-12">
          <div  class="float-right row maap-right-controls">
              <div  class="col-md-6 mt-2"></div>
              <div  class="col-md-6"></div>
          </div>
      </div>
      <div class="col-md-12 px-5">
        <router-outlet></router-outlet>
        <!-- <app-table></app-table> -->
      </div>
  </div>
</div>
